import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import BorseContext from "../../context/borse";
import UserContext from "../../context/user";
import { computePartial } from "../../utils/partial";

const useBorseRequestCreateMutation = (closeModal) => {
  const { callApi, userProfile } = useContext(UserContext);
  const { handleNext, setFormData, setCurrentRequest, setRequests } = useContext(BorseContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({ survey, campaignId, formData, values, email, phone, isRequestForMe, lastCompletedStep }) =>
      callApi(`/scholarship/request/${campaignId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...(email ? { welfareEmail: email } : {}),
          ...(phone ? { welfarePhone: phone } : {}),
          ...(isRequestForMe !== undefined ? { requestForMe: isRequestForMe } : {}),
          ...(typeof lastCompletedStep === "number" ? { lastCompletedStep } : {}),
          surveyAnswer: {
            contentId: Number(survey.contentId),
            ...computePartial(survey, { ...formData, ...values }),
          },
        }),
      }),
    {
      onSuccess: (data, variables) => {
        if (data?.id) {
          setRequests((current) =>
            current.map((request) => (request.id === data.id ? data : request))
          );
          setCurrentRequest(data);
          setFormData((current) => ({ ...current, ...variables.values }));
          if (closeModal) {
            closeModal();
            setCurrentRequest();
            queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
          } else {
            handleNext(data?.id);
          }
        }
      },
    }
  );
};

export default useBorseRequestCreateMutation;
